/* eslint-disable jira/filename-case */
const connectRoutes: RegExp[] = [
	// Regex groups: addonKey, pageKey
	/\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i,
];

export default connectRoutes;
